import { render } from "./AccountDomains.vue?vue&type=template&id=4d0149e4&scoped=true"
import script from "./AccountDomains.vue?vue&type=script&lang=js"
export * from "./AccountDomains.vue?vue&type=script&lang=js"

import "./AccountDomains.vue?vue&type=style&index=0&id=4d0149e4&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0149e4"]])

export default __exports__